export default "__VITE_ASSET__DL_1rxeQ__"